import ErrorWrapper from './error-wrapper';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Link from '@mui/material/Link';

export default function InvalidDomainPage() {
  const location = useLocation();

  type LocationState = {
    loggedInUserEmail?: string;
    primaryDomain?: string;
  } | null;

  const state = location.state as LocationState;
  const loggedInUserEmail = state?.loggedInUserEmail || 'unknown user';
  const primaryDomain = state?.primaryDomain || 'unknown domain';

  return (
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader
          title={'Access Denied'}
          subheader={
            <>
              You are currently logged in as{' '}
              <Box component="span" sx={{ fontWeight: 'bold' }}>
                {loggedInUserEmail}
              </Box>
              . The domain{' '}
              <Box component="span" sx={{ fontWeight: 'bold' }}>
                {primaryDomain}
              </Box>{' '}
              has been flagged as an invalid domain. Please contact{' '}
              <Link href="mailto:support@promevo.com">support@promevo.com</Link>{' '}
              for further details and assistance.
            </>
          }
        />
      </Card>
    </ErrorWrapper>
  );
}
